import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const particle = defineConnector({
  identifier: "particle",
  name: "Particle",
  tagLine: "Cloud platform for IoT devices",
  logo,
  protocol: "http",
  tags: ["engineering", "it"],
  defaultUrlPattern: () => "https://api\\.particle\\.io/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Create a durable access token with the Particle CLI by running `particle token create --never-expires`, or add an API user (in your product or organization’s Team tab, choose “Add API user”) for a non-expiring token scoped to the APIs you need. Copy the token.",
        },
      ],
    },
    {
      title: "Paste your access token below",
      items: [
        {
          kind: "input",
          label: "Particle access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.particle.io/v1/devices",
  },
});
